export const API_URL = "https://api.themoviedb.org/3/"